<template lang="pug">
  .new-order
    shForm(title="New Order")
</template>

<script>
import shForm from '@/components/pages/order/Form'

export default {
  name: 'NewOrder',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-order
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/order/New.vue